import { useMemo } from "react";
import { useFSBooleanFlag } from "../../context/fs/useFSBooleanFlag";
import { COMBINE_ENCN_FLAG, DEFAULT_ENCN_BEHAVIOUR } from "./constants";
export var useENCNConfig = function () {
    var checkFlag = useFSBooleanFlag();
    return useMemo(function () {
        return checkFlag(COMBINE_ENCN_FLAG, DEFAULT_ENCN_BEHAVIOUR);
    }, [checkFlag]);
};
